import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.7 7.5H2.3L7.8 2c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.2.2.5.2.7 0s.2-.5 0-.7L2.3 8.5h12.5c.3 0 .5-.2.5-.5-.1-.3-.3-.5-.6-.5" />
  </svg>
);
const SvgArrowLeft = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="arrow-left" {...props} />;
export default SvgArrowLeft;
